import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useFetchHistoricContentMutation } from '../api/client'
import PageMasthead from '../components/PageMasthead'
import MastheadBreadcrumb from '../components/MastheadBreadcrumb'

const DEFAULT_TWEETS_REQUESTED = 1000

function FetchHistoricContentPage() {
    let { accountId: accountIdString } = useParams()
    const accountId = Number(accountIdString)
    const [tweetsRequested, setTweetsRequested] = useState(DEFAULT_TWEETS_REQUESTED)

    const [requestSent, setRequestSent] = useState(false)

    const [fetchHistoricContent] = useFetchHistoricContentMutation()
    const onFetchHistoricContent = async () => {
        await fetchHistoricContent({
            variables: {
                accountId,
                tweetsRequested
            }
        })
        setRequestSent(true)
    }

    function handleChange(event: React.FormEvent<HTMLInputElement>) {
        const newKeyword = event.currentTarget.value
        setTweetsRequested(Number(newKeyword))
    }

    return (
        <>
            <PageMasthead
                title="Fetch historic content"
                tabTitle="Fetch historic content"
                breadcrumb={
                    <MastheadBreadcrumb
                        to={`/account/${accountId}/settings`}
                        label="Profile settings"
                    />
                }
            />
            <div className="p-12 bg-white h-screen">
                <article className="prose lg:prose-l">
                <h3>Known limitations</h3>
                <ul>
                    <li>
                        Only the last 7 days of content are available — the X search API does not
                        return anything older.
                    </li>
                    <li>
                        Only direct replies to this profile's own posts are fetched. Plain
                        @mentions, and replies deeper in a thread (replies to other people's
                        replies), are not captured.
                    </li>
                    <li>
                        Every comment read is billed on our pay-per-use X plan (about $0.005 per
                        read, so the default 1,000 costs about $5), and the requested number rounds
                        up to a full page of 100.
                    </li>
                    <li>
                        Re-running a fetch reads — and bills — the same comments again. It will not
                        create duplicates in Arwen.
                    </li>
                    <li>
                        Content arrives over several minutes (one page of 100 per fetch request) and
                        then flows through classification and moderation like live comments.
                    </li>
                </ul>

                <label htmlFor="tweetsRequested" className="block text-sm  text-gray-700">
                    Number of historic comments to fetch
                </label>
                <div className="mt-1 flex">
                    <input
                        value={tweetsRequested}
                        type="number"
                        id="tweetsRequested"
                        name="tweetsRequested"
                        step={500}
                        onChange={handleChange}
                        className="shadow-sm focus:ring-primary-500 focus:border-primary block border-gray-300 rounded-md"
                    />
                    {!requestSent ? (
                        <button
                            type="button"
                            onClick={async () => await onFetchHistoricContent()}
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow px-4 py-2 bg-red-600 text-base  text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        >
                            Fetch historic content
                        </button>
                    ) : null}
                    {requestSent ? <div className="pl-4 pt-2">Request sent</div> : null}
                </div>
            </article>
            </div>
        </>
    )
}

export default FetchHistoricContentPage
